import { useEffect } from "react";
import OneSignal from "react-onesignal";

import "./App.css";

import { GameList } from "./views/GameList";

import { Box } from "@mui/material";
import { Amplify } from "aws-amplify";
// import { DataStore } from "@aws-amplify/datastore";
import awsconfig from "./aws-exports";
// import { schema } from "./models/schema";
import "@aws-amplify/ui-react/styles.css";

// ❌ DATASTORE SYNC FUNKTIONIERT NICHT ZUVERLÄSSIG!
// → Wir verwenden NUR die API direkt, KEIN DataStore.save()!
// → createGame() muss umgeschrieben werden, um API.graphql() zu verwenden

Amplify.configure(awsconfig);

console.log("✅ Amplify configured (API ONLY, NO DataStore sync!)");
console.log("  📡 GraphQL Endpoint:", awsconfig.aws_appsync_graphqlEndpoint);
console.log("  🔑 Auth Type:", awsconfig.aws_appsync_authenticationType);
console.log("  🗝️  API Key present:", !!awsconfig.aws_appsync_apiKey);
console.log("  ⚠️  DataStore sync DISABLED - using API.graphql() instead!");

// Add the type definitions here or in a separate file
type PushSubscriptionNamespaceProperties = {
  id: string | null | undefined;
  token: string | null | undefined;
  optedIn: boolean;
};

interface SubscriptionChangeEvent {
  previous: PushSubscriptionNamespaceProperties;
  current: PushSubscriptionNamespaceProperties;
}

function App() {
  useEffect(() => {
    // Define the event handler with the correct type
    const onSubscriptionChange = (change: SubscriptionChangeEvent) => {
      const newPlayerId = change.current.id;
      handlePlayerId(newPlayerId);
    };

    const handlePlayerId = (playerId: string | null | undefined) => {
      if (playerId) {
        console.log("OneSignal Player ID:", playerId);
        // Send the playerId to your backend to associate with the user
        savePlayerIdToBackend(playerId);
      } else {
        console.warn(
          "Player ID is null or undefined. User may not be subscribed."
        );
        // Optionally prompt the user to subscribe
        OneSignal.Slidedown.promptPush();
      }
    };

    const initializeOneSignal = async () => {
      // Only initialize OneSignal on localhost for now
      // TODO: Configure production domain in OneSignal dashboard
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        try {
          await OneSignal.init({
            // appId: "a48add1e-1780-4772-a5c8-c857b229632c",
            appId: "0fb7422a-a233-4d8e-b868-26f6b4b1528d",

            safari_web_id:
              "web.onesignal.auto.34975c41-96f8-43c9-89c6-048b8e5234aa",
            notifyButton: {
              enable: true,
              prenotify: true,
              showCredit: false,
              text: {
                "dialog.blocked.message":
                  "Benachrichtigungen wurden blockiert. Bitte prüfe deine Browser-Einstellungen.",
                "dialog.blocked.title": "Benachrichtigungen blockiert",
                "dialog.main.button.subscribe": "Aktivieren",
                "dialog.main.button.unsubscribe": "Deaktivieren",
                "dialog.main.title": "Benachrichtigungen verwalten",
                "message.action.resubscribed": "Du erhältst weiterhin Updates",
                "message.action.subscribed": "Danke für's Abonnieren!",
                "message.action.unsubscribed": "Benachrichtigungen deaktiviert",
                "message.action.subscribing":
                  "Aktiviere Benachrichtigungen ...",
                "message.prenotify":
                  "Klicke zum Aktivieren der Benachrichtigungen",
                "tip.state.unsubscribed": "Benachrichtigungen aktivieren",
                "tip.state.subscribed": "Benachrichtigungen sind aktiv",
                "tip.state.blocked":
                  "Benachrichtigungen sind im Browser deaktiviert",
              },
            },
            // Uncomment the below line to run on localhost. See: https://documentation.onesignal.com/docs/local-testing
            allowLocalhostAsSecureOrigin: true,
          });

          // Check if the user is already subscribed
          const playerId = OneSignal.User.PushSubscription.id;
          if (playerId) {
            console.log("OneSignal Player ID:", playerId);
            savePlayerIdToBackend(playerId);
          } else {
            console.log("User is not subscribed to push notifications.");
            // Optionally prompt the user to subscribe
            OneSignal.Slidedown.promptPush();
          }

          // Listen for subscription changes
          OneSignal.User.PushSubscription.addEventListener(
            "change",
            onSubscriptionChange
          );
        } catch (error) {
          console.error("OneSignal initialization failed:", error);
        }
      } else {
        console.log("OneSignal disabled in production (domain not configured)");
      }
    };

    initializeOneSignal();

    return () => {
      // Clean up the event listener when the component unmounts
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        try {
          OneSignal.User.PushSubscription.removeEventListener(
            "change",
            onSubscriptionChange
          );
        } catch (error) {
          // Ignore cleanup errors
        }
      }
    };
  }, []);

  return (
    <Box className="App">
      {/* Everyone can use the app - login is optional */}
      <GameList />
    </Box>
  );
}

export default App;

async function savePlayerIdToBackend(playerId: string) {
  try {
    // Replace with your actual API endpoint and authentication logic
    await fetch("/api/save-player-id", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Include authentication headers if necessary
      },
      body: JSON.stringify({ playerId }),
    });
  } catch (error) {
    console.error("Error saving player ID to backend:", error);
  }
}
